const translator = require("./translator.js");

const fieldsRegex = {
  email: {
    regEx:
      /^(?=.{1,255}$)[a-zA-Z0-9][a-zA-Z0-9+\-_]*(\.[a-zA-Z0-9+\-_]+)*@[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?)+$/, // eslint-disable-line
  },

  emailLogin: {
    regEx:
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, // eslint-disable-line
  },

  password: {
    regEx: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@+.'"\-?><=/*\\|(),#$%^&*]{7,}$/
  },

  numbersOnly: {
    regEx: /^[0-9]+$/,
  },

  includeNumber: {
    regEx: /[0-9]/,
  },

  /* An optional plus sign at the start, followed by a minimum of 6 digits,
  and then any combination of digits, parentheses, forward slashes, 
  whitespaces, or hyphens to the end of the string.*/
  PhoneSymbols: {
    regEx: /^\+?\d{6,}[0-9()/\s-]*$/   //^(?!.*[\+\-\s])(?=.*[a-zA-Z])(?=.*[^a-zA-Z\s])[a-zA-Z\d!@#\$%\^&\*\(\)_\+\[\]\{\};:\'"\|<,>\.\?\/\\\-]+$  /[A-Za-z!-/:-@[-`{-~-]/ 
  },

  ukPostalCode: {
    regEx: /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? [0-9][A-Za-z]{2}|[Gg][Ii][Rr] 0[Aa]{2})$/
  },
  frPostalCode: {
    regEx:/^(?!00000)[0-9]{5}$/,
  },
  chPostalCode: {
    regEx: /^[0-9]{4}$/,
  },
};

const validatePasswordLogin = (password, languageForErrorMsg) => {
  if (!password || password.length === 0) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_mandatory_field"
      ),
    };
  } else {
    return { isValid: true, errorMsg: "" };
  }
};

const validatePassword = (password, languageForErrorMsg, email) => {
  if (password.length === 0) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_mandatory_field"
      ),
    };
  }

  if (email && password.toLowerCase() === email.toLowerCase()) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_password_same_as_email"
      ),
    };
  }

  if (!fieldsRegex.password.regEx.test(password)) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_enter_valid_data"
      ),
    };
  } else {
    return { isValid: true, errorMsg: "" };
  }
};



const validateRepeatPassword = (
  password,
  repeatPassword,
  languageForErrorMsg
) => {
  if (!repeatPassword || repeatPassword.length === 0) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_mandatory_field"
      ),
    };
  }

  if (password !== repeatPassword) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_repeat_password"
      ),
    };
  } else {
    return { isValid: true, errorMsg: "" };
  }
};

const validateConfirmEmail = (
  email,
  confirmEmail,
  languageForErrorMsg
) => {
  if (!confirmEmail || confirmEmail.length === 0) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_mandatory_field"
      ),
    };
  }

  const normalizedEmail = email.trim().toLowerCase();
  const normalizedConfirmEmail = confirmEmail.trim().toLowerCase();

  if (normalizedEmail !== normalizedConfirmEmail) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_confirm_email"
      ),
    };
  } else {
    return { isValid: true, errorMsg: "" };
  }
};

const validateMandatory = (fieldValue, languageForErrorMsg) => {
  if (!fieldValue || fieldValue.length === 0) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_mandatory_field"
      ),
    };
  }

  else return { isValid: true, errorMsg: "" };
};



const validateCompany = (fieldValue, languageForErrorMsg) => {
  //not a mandatory field!
  if (!fieldValue || fieldValue.length < 35) {
    return {
      isValid: true,
      errorMsg: "",
    };
  } else {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_enter_valid_data"
      ),
    };
  }
};

const validateName = (fieldValue, languageForErrorMsg) => {
  // Check if value is null, undefined, or empty after trimming whitespace
  if (!fieldValue || fieldValue.trim().length === 0) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_mandatory_field"
      ),
    };
  }

  // Check if name has only one character or contains digits
  if (/[0-9]/.test(fieldValue) || fieldValue.trim().length === 1) {
    //if name size is 1 or consists digits
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_enter_valid_data"
      ),
    };
  } else return { isValid: true, errorMsg: "" };
};

const validateCustomerName = (fieldValue, languageForErrorMsg) => {
  if (!fieldValue || fieldValue.length === 0) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_mandatory_field"
      ),
    };
  }

  if (/[0-9]/.test(fieldValue) || fieldValue.length === 1 || /[^a-zA-Z\s]/.test(fieldValue)) {
    //if name size is 1 or consists digits or contains special characters
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_enter_valid_data"
      ),
    };
  } else return { isValid: true, errorMsg: "" };
};

const validateEmail = (email, languageForErrorMsg) => {
  if (!email || email.length === 0) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_mandatory_field"
      ),
    };
  }

  if (!fieldsRegex.email.regEx.test(email))
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_invalid_email_format"
      ),
    };
  else return { isValid: true, errorMsg: "" };
};

const validateEmailLogin = (email, languageForErrorMsg) => {
  if (!email || email.length === 0) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_mandatory_field"
      ),
    };
  }

  if (!fieldsRegex.emailLogin.regEx.test(email))
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_enter_valid_data"
      ),
    };
  else return { isValid: true, errorMsg: "" };
};

const validatePhone = (phone, languageForErrorMsg) => {
  if (!phone || phone.length === 0) {
    return { "isValid": false, "errorMsg": translator.translate(languageForErrorMsg, "default", "LoginQuestion/validation_mandatory_field") };
  }
  else if (fieldsRegex.PhoneSymbols.regEx.test(phone)) {
    return { "isValid": true, "errorMsg": "" };
  }
  else {
    return { "isValid": false, "errorMsg": translator.translate(languageForErrorMsg, "shipping", "ShippingForm/validation_phone") };
  }
}

const normalizePhone = (raw) => {
  // Strip bidi/ZW/BOM/soft-hyphen (paste noise) before format cleanup
  let cleaned = String(raw ?? '')
    .replace(/[\u200B-\u200F\u202A-\u202E\uFEFF\u00AD]/g, '')
    .trim()
    .replace(/[\s\-()/]/g, '');

  if (cleaned.startsWith('+00')) {
    cleaned = '+' + cleaned.slice(3);
  } else if (cleaned.startsWith('+0')) {
    cleaned = '+49' + cleaned.slice(2);
  }

  if (!cleaned.startsWith('+')) {
    if (cleaned.startsWith('00')) {
      cleaned = '+' + cleaned.slice(2);
    } else if (cleaned.startsWith('0')) {
      cleaned = '+49' + cleaned.slice(1);
    } else if (cleaned.startsWith('49') && cleaned.length > 6) {
      cleaned = '+' + cleaned;
    } else {
      cleaned = '+49' + cleaned;
    }
  }

  if (cleaned.startsWith('+49')) {
    const nationalPart = cleaned.slice(3);
    const stripped = nationalPart.replace(/^0+/, '');
    if (stripped.length > 0) {
      cleaned = '+49' + stripped;
    }
  }

  return cleaned;
};

const validatePhoneDE = (phone, languageForErrorMsg) => {
  if (process.env.REACT_APP_ENV === 'development') {
    return { isValid: true, errorMsg: "" };
  }

  if (!phone || phone.length === 0) {
    return { isValid: false, errorMsg: translator.translate(languageForErrorMsg, "default", "LoginQuestion/validation_mandatory_field") };
  }

  const normalized = normalizePhone(phone);

  if (!/^\+\d+$/.test(normalized)) {
    return {
      isValid: false,
      errorMsg: translator.translate(languageForErrorMsg, "shipping", "ShippingForm/validation_phone_invalid_with_hint")
    };
  }

  const digits = normalized.slice(1);

  if (digits.startsWith('49')) {
    const nationalNumber = digits.slice(2);

    // German numbers are max 13 digits (incl. country code).
    // If longer, the user likely forgot '+' on a foreign number (e.g. 90 532... → +4990532...).
    if (digits.length > 13) {
      return {
        isValid: false,
        errorMsg: translator.translate(languageForErrorMsg, "shipping", "ShippingForm/validation_phone_invalid_with_hint")
      };
    }

    const isMobilePrefix = /^1[567]/.test(nationalNumber);

    if (!isMobilePrefix) {
      if (/^[2-9]/.test(nationalNumber)) {
        return {
          isValid: false,
          errorMsg: translator.translate(languageForErrorMsg, "shipping", "ShippingForm/validation_phone_de_landline")
        };
      }
      return {
        isValid: false,
        errorMsg: translator.translate(languageForErrorMsg, "shipping", "ShippingForm/validation_phone_invalid_with_hint")
      };
    }

    if (nationalNumber.length < 10 || nationalNumber.length > 11) {
      return {
        isValid: false,
        errorMsg: translator.translate(languageForErrorMsg, "shipping", "ShippingForm/validation_phone_de_length")
          .replace(':digit_count', String(digits.length))
      };
    }

    return { isValid: true, errorMsg: "", e164: normalized };
  }

  if (digits.length < 7 || digits.length > 15) {
    return {
      isValid: false,
      errorMsg: translator.translate(languageForErrorMsg, "shipping", "ShippingForm/validation_phone_invalid")
    };
  }

  return { isValid: true, errorMsg: "", e164: normalized };
};


const validatePostalCode = (postalCode, languageForErrorMsg, destionationCountry) => {
  if (destionationCountry === "de") {
    if (!postalCode || postalCode.length === 0) {
      return { "isValid": false, "errorMsg": translator.translate(languageForErrorMsg, "default", "LoginQuestion/validation_mandatory_field") };
    }

    else if (postalCode.length !== 5 || !fieldsRegex.numbersOnly.regEx.test(postalCode)) {
      return { "isValid": false, "errorMsg": translator.translate(languageForErrorMsg, "shipping", "ShippingForm/validation_postal_code") };
    }

    else {
      return { "isValid": true, "errorMsg": "" }
    }
  }

  if (destionationCountry === "ch") {
    if (!postalCode || postalCode.length === 0) {
      return { "isValid": false, "errorMsg": translator.translate(languageForErrorMsg, "default", "LoginQuestion/validation_mandatory_field") };
    }
  
    else if (!fieldsRegex.chPostalCode.regEx.test(postalCode)) {
      return { "isValid": false, "errorMsg": translator.translate(languageForErrorMsg, "shipping", "ShippingForm/validation_postal_code_ch") };
    }
  
    else {
      return { "isValid": true, "errorMsg": "" };
    }
  }


  if (destionationCountry === "gb") {
    if (!postalCode || postalCode.length === 0) {
      return {
        isValid: false,
        errorMsg: translator.translate(
          languageForErrorMsg,
          "default",
          "LoginQuestion/validation_mandatory_field"
        ),
      };
    } else if (!fieldsRegex.ukPostalCode.regEx.test(postalCode)) {
      return {
        isValid: false,
        errorMsg: translator.translate(
          languageForErrorMsg,
          "shipping",
          "ShippingForm/validation_postal_code"
        ),
      };
    } else {
      return { isValid: true, errorMsg: "" };
    }
  }
  if (destionationCountry === "fr") {
    if (!postalCode || postalCode.length === 0) {
      return {
        isValid: false,
        errorMsg: translator.translate(
          languageForErrorMsg,
          "default",
          "LoginQuestion/validation_mandatory_field"
        ),
      };
    } else if (
      postalCode.length !== 5 ||
      !fieldsRegex.frPostalCode.regEx.test(postalCode)
    ) {
      return {
        isValid: false,
        errorMsg: translator.translate(
          languageForErrorMsg,
          "shipping",
          "ShippingForm/validation_postal_code"
        ),
      };
    } else {
      return { isValid: true, errorMsg: "" };
    }
  } else {
    return { isValid: true, errorMsg: "" };
  }
};
const isDigitsOnly = (input) => {// string -> boolean
  // Remove whitespace and check if it's not empty and contains only digits
  const trimmed = input.trim();
  return  /^\d+$/.test(trimmed);
};

const validateStreetAndNumber = (streetAndNumber, language) => {
  let validationResult = { isValid: true, errMsgPath: "" };
  
  if (!streetAndNumber || streetAndNumber.length === 0) {
    validationResult.errMsgPath = "LoginQuestion/validation_mandatory_field";
  }
  else if (isDigitsOnly(streetAndNumber)) {
    validationResult.errMsgPath = "AddressValidationModal/no-letters";
  }
  else if (streetAndNumber.length === 1 || !fieldsRegex.includeNumber.regEx.test(streetAndNumber)) {
    validationResult.errMsgPath = "LoginQuestion/validation_enter_valid_data";
  }
  
  // If we have an error path, the validation failed
  if (validationResult.errMsgPath) {
    return {
      isValid: false,
      errorMsg: translator.translate(language, "default", validationResult.errMsgPath)
    };
  }
  
  // Success case
  return {
    isValid: true,
    errorMsg: ""
  };
};

const validatePackstationNumber = (packstationNumber, languageForErrorMsg) => {
  //packstation is a string because it's an input
  if (!packstationNumber || packstationNumber.length === 0) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_mandatory_field"
      ),
    };
  } else if (
    packstationNumber < 10 ||
    !fieldsRegex.numbersOnly.regEx.test(packstationNumber)
  ) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_enter_valid_data"
      ),
    };
  } else {
    return { isValid: true, errorMsg: "" };
  }
};

const validatePostNumber = (postNumber, languageForErrorMsg) => {
  //postNumber is a string because it's an input
  if (!postNumber || postNumber.length === 0) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_mandatory_field"
      ),
    };
  } else if (
    postNumber.length < 6 ||
    !fieldsRegex.numbersOnly.regEx.test(postNumber)
  ) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_enter_valid_data"
      ),
    };
  } else {
    return { isValid: true, errorMsg: "" };
  }
};




const areQuestionsFilled = (questionsValidationObject) => {
  let questionsFilled = true;

  for (let key of Object.keys(questionsValidationObject)) {
    if (!questionsValidationObject[key].isFilled) questionsFilled = false;
  }

  return questionsFilled;
};

const areQuestionsValid = (questionsValidationObject) => {
  let questionsValid = true;

  for (let key of Object.keys(questionsValidationObject)) {
    if (!questionsValidationObject[key].isValid) questionsValid = false;
  }

  return questionsValid;
};

const areSubQuestionsFilled = (subQuestionsValidationObject) => {
  let subQuestionsFilled = true;

  for (let key of Object.keys(subQuestionsValidationObject)) {
    if (
      !subQuestionsValidationObject[key].isFilled &&
      subQuestionsValidationObject[key].isDisplayed
    )
      subQuestionsFilled = false;
  }

  return subQuestionsFilled;
};

const areSubQuestionsValid = (subQuestionsValidationObject) => {
  let subQuestionsValid = true;

  for (let key of Object.keys(subQuestionsValidationObject)) {
    if (
      !subQuestionsValidationObject[key].isValid &&
      subQuestionsValidationObject[key].isDisplayed
    )
      subQuestionsValid = false;
  }

  return subQuestionsValid;
};

const validateMessage = (message, languageForErrorMsg) => {
  if (!message || message.length < 20) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "contact",
        "ContactPageForm/message_error"
      ),
    };
  } else {
    return { isValid: true, errorMsg: "" };
  }
};

const validHashID = (hashID, languageForErrorMsg) => {
  if (!hashID || hashID.length < 7 || hashID.length > 11) { // if not exists or not between 7-11
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "contact",
        "ContactPageForm/order_number_error"
      ),
    };
  } else {
    return { isValid: true, errorMsg: "" };
  }
}

const validateByField = (field, value, language, destionationCountry) => {
  switch (field) {
    case "email":
      return validateEmail(value, language);

    case "password":
    case "old_password":
      return validatePassword(value, language);


    case "packstation_address":
        return validatePackstationAddress(value, language);
    case "packstation_personal_address":
    case "address":
    case "billing_address":

      return validateStreetAndNumber(value, language);

    case "name":
    case "first_name":
    case "billing_first_name":
    case "packstation_personal_first_name":
    case "last_name":
    case "billing_last_name":
    case "packstation_personal_last_name":
    case "city":
    case "street":
    case "packstation_personal_city":
    case "packstation_city":
    case "billing_city":
    case "nameAndSurname":
    case "additional_info":
      return validateName(value, language);

    case "zip":
    case "billing_zip":
    case "packstation_zip":
    case "packstation_personal_zip":
    case "postal":
      return validatePostalCode(value, language, destionationCountry);

    case "company":
      return validateCompany(value, language);

    case "phone":
    case "packstation_personal_phone":
      return validatePhone(value, language);


    case "packstation_number":
      return validatePackstationNumber(value, language);

    case "day":
    case "loginPassword":
    case "month":
    case "year":
    case "gender":
    case "agree_to_terms":
    case "house_number":
      return validateMandatory(value, language);

    case "message":
    case "content":
      return validateMessage(value, language);
  
    case "orderNumber":
      return validHashID(value, language);

    default:
      return { isValid: true, errorMsg: "" };
  }
};

const validatePackstationAddress = (address, languageForErrorMsg) => {
  if (!address || address.length === 0) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_mandatory_field"
      ),
    };
  } else if (
    !fieldsRegex.numbersOnly.regEx.test(address)
  ) {
    return {
      isValid: false,
      errorMsg: translator.translate(
        languageForErrorMsg,
        "default",
        "LoginQuestion/validation_enter_valid_data"
      ),
    };
  } else {
    return { isValid: true, errorMsg: "" };
  }
};

module.exports = {
  validateByField,
  validateName,
  validateCustomerName,
  validatePassword,
  validatePasswordLogin,
  validateEmail,
  validateEmailLogin,
  validateMandatory,
  validateCompany,
  validateRepeatPassword,
  validateConfirmEmail,
  validatePostalCode,
  validateStreetAndNumber,
  validatePackstationNumber,
  validatePostNumber,
  validatePhone,
  normalizePhone,
  validatePhoneDE,
  areQuestionsFilled,
  areQuestionsValid,
  areSubQuestionsFilled,
  areSubQuestionsValid,
  validatePackstationAddress,
};
